// extracted by mini-css-extract-plugin
export default {"mainSection":"ResetPasswordFailedPage_mainSection__ZR-Ck"};